export enum INCIDENCE_PERMISSIONS {
  INCIDENCE_VIEW = 'INCIDENCE_VIEW',
  INCIDENCE_WRITE = 'INCIDENCE_WRITE',
}

export enum INCIDENCE_ACTIONS_PERMISSIONS {
  VIEW = 'INCIDENCE_ACTIONSVIEW',
  WRITE = 'INCIDENCE_ACTIONSWRITE',
}
